import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip  } from 'antd';
import Swal from 'sweetalert2'
import { URL,api } from '../../api';

export default class Modalsenttouser extends Component {
    constructor(props) {
        super(props);
        this.state = {
          modal: false,

          inside:"",
          faculty:"",
          Expert:[],
          idExpert:"",
          send_comment1:"",
          success:"",
          filecomment1:null,

          id_send:"",
          id_comment:"",
          id_bn:"",
          show:"",
          comment_admin:"",

        }

this.handleChange = this.handleChange.bind(this);
this.handleSubmit = this.handleSubmit.bind(this);
this.toggle = this.toggle.bind(this);
this.handleChangetype = this.handleChangetype.bind(this);
}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
  //this.props.selectatf();
}

handleChangetype(event) {    this.setState({comment_admin: event.target.value});  }


 componentDidMount() {
      const { id_send } = this.props.id_send
    //  console.log(this.props.id_send);
      this.setState({   id_send:this.props.id_send,
                        id_comment:this.props.id_comment,
                        id_bn:this.props.id_bn
                    })

  }

//   getExpert() {
//     setTimeout(() => {
//       //ภายใน
//        Axios.get('https://conference.kpru.ac.th/PHPAPI/selectExpert.php')
//       .then(res => {
//         console.log(res);
//       //  this.setState({ bankname: res.data, loading: false })
//         this.setState({ Expert: res.data})
//       }) 

//     }, 0);

// }


  handleChange(event) {    this.setState({show: event.target.value});  }



  handleSubmit() {
    // alert('A name was submitted: ' + this.state.value);
   setTimeout(() => {

      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("id_sendarticle", this.state.id_send);
      datafrm.append("id_commentexbn", this.state.id_comment);
      datafrm.append("id_experten", this.state.id_bn);
      datafrm.append("status_show", this.state.show);
      datafrm.append("comment_admin", this.state.comment_admin);

//อัพเดทสถานะ
api.post("registercon/updateexpertbncommentadmin",datafrm)
    .then(res => {
      console.log("response: ", res)

      if (res.data = '200') {
   
        Swal.fire({
         title: 'แจ้งผู้เขียนสำเร็จ',
         text: "Successfully notified author",
         icon: 'success',
         showCancelButton: false,
         confirmButtonColor: '#3085d6',
         cancelButtonColor: '#d33',
         confirmButtonText: 'ตกลง'
       }).then((result) => {
         if (result.isConfirmed) {
             this.props.list()
             this.toggle()
         }
       })
       
       }else{
             message.error("อัพโหลไฟล์ไม่สำเร็จ!")
       }
 
  
   })

 
}, 1000);

  }

  

    render() {

    //  console.log(this.state.show) 
    //  console.log(this.state.comment_admin) 
        
        return (
            <>
            <MDBBtn color="cyan" onClick={this.toggle} size='sm'>แจ้งสถานะ</MDBBtn>

            <MDBModal isOpen={this.state.modal} toggle={this.toggle}>
              <MDBModalHeader toggle={this.toggle}>แจ้งสถานะบทความ </MDBModalHeader>
              <MDBModalBody>
              <div>

              <p>แจ้งสถานะบทความ</p>
                <select className="browser-default custom-select" onChange={this.handleChange}>
                        <option>------กรุณาเลือกสถานะ------</option>
                        <option value="0">ไม่ส่งแจ้ง</option>
                        <option value="1">ส่งแจ้ง</option>
                </select>

              <div className="mb-2 mt-2">
                           <label><strong>ข้อเสนอแนะ</strong></label>
                           <input className="form-control" onChange={this.handleChangetype} name="comment_admin"
                                    value={this.state.comment_admin} placeholder="กรุณาข้อเสนอแนะ" required />
              </div>



              </div>
              </MDBModalBody>
              <MDBModalFooter>
                 <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn>
                <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
               
              </MDBModalFooter>
            </MDBModal>
          </>
          
        )
    }
}
